<ul class="{{hotspot_container_class}}">
  {{#each hotspots}}
    <li {{#if animation}}data-anijs="{{animation}}"{{/if}} class="hotspot {{id}} {{class}}" id={{id}} tabindex="0">
        <a class="front {{link_class}}" role="button" 
          {{#if front_aria_label}}aria-label="{{t front_aria_label}}"{{/if}} tabindex="-1">
          {{#if ../default_icon_clicked.name}}
          {{!-- Legacy icon --}}
            {{>icon uuid=../cid index=@index prefix=../default_icon_clicked.prefix name=../default_icon_clicked.name sr_caption=header}}
          {{else}}
            {{>icon uuid=../cid index=@index icon=../default_icon_clicked sr_caption=header}}
          {{/if}}
        {{#if sr_text}}<div class="screen-reader-content">{{t sr_text}}</div>{{/if}}
        <div class="header" {{#if sr_text}}aria-hidden="true"{{/if}}>
          {{#if header_icon_unclicked}}
            {{#if header_icon_unclicked.name}}
              {{#if header_icon_unclicked.prefix}}
              {{!-- Legacy icon --}}
                {{>icon uuid=../cid index=@index prefix=header_icon_unclicked.prefix name=header_icon_unclicked.name sr_caption=header}}
              {{/if}}
            {{else}}
            {{>icon uuid=../cid index=@index icon=header_icon_unclicked sr_caption=header}}
            {{/if}}
            {{else}}
              {{t header}}
            {{/if}}
        </div>
        {{#unless ../with_back}}
          <div class="description" {{#if sr_text}}aria-hidden="true"{{/if}}>{{t description}}</div>
          <div class="checkbox"></div>
        {{/unless}}
      </a>
      {{#if ../with_back}}
        <a href="#" class="back" role="dialog">
          {{#if ../closable_back}}
          <button class="close-btn" data-hotspot="{{id}}" {{#if close_button_aria_label}}aria-label="{{t close_button_aria_label}}"{{/if}}>{{#if close_button_text}}{{t close_button_text}}{{/if}}</button>
          {{/if}}

          {{#if badge_class}}
            <div class="{{badge_class}}"></div>
          {{/if}}

          {{#if sr_back_text}}<div class="screen-reader-content">{{t sr_back_text}}</div>{{/if}}
          <div class="header" {{#if sr_back_text}}aria-hidden="true"{{/if}}>{{t header}}</div>
          <div class="description" {{#if sr_back_text}}aria-hidden="true"{{/if}}>{{t description}}</div>
          <div class="checkbox"></div>
        </a>
      {{/if}}
      {{#if blocks}}<div data-region="{{../cid}}-hotspots-{{@index}}-blocks"></div>{{/if}}
    </li>
  {{/each}}
</ul>
